import React, { Suspense } from 'react';
import useNotifyModal from './common/hook/useNotifyModal';

const ErrorNotifyModal = React.lazy(() => import(/* webpackChunkName: "ErrorNotifyModal" */ './common/Modal/ErrorNotifyModal'));
const ConfirmNotifyModal = React.lazy(() => import(/* webpackChunkName: "ConfirmNotifyModal" */ './common/Modal/ConfirmNotifyModal'));
const StoreClosedNotifyModal = React.lazy(() => import(/* webpackChunkName: "StoreClosedNotifyModal" */ './common/Modal/StoreClosedNotifyModal'));

const NotifyContainer = () => {
  const modal = useNotifyModal();
  if (modal.mode === 'confirm') {
    return (
      <Suspense fallback={<div />}>
        <ConfirmNotifyModal
          isOpen={modal.openModal}
          showCancel={!!modal.cancelText}
          title={modal.title}
          description={modal.description}
          closeText={modal.cancelText}
          confirmText={modal.buttonText}
          onClose={modal.closeModal}
          onConfirm={modal.onConfirm}
        />
      </Suspense>
    );
  }
  if (modal.type === 'warning_store_closed') {
    return (
      <Suspense fallback={<div />}>
        <StoreClosedNotifyModal
          open={modal.openModal}
          showCancel={!!modal.cancelText}
          title={modal.title}
          description={modal.description}
          closeText={modal.cancelText}
          confirmText={modal.buttonText}
          onClose={modal.closeModal}
          onNext={modal.onNext}
          onConfirm={modal.onConfirm}
        />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<div />}>
      <ErrorNotifyModal
        open={modal.openModal}
        title={modal.title}
        description={modal.description}
        buttonText={modal.buttonText}
        onClose={modal.closeModal}
        type={modal.type}
        errorDescription={modal.errorDescription}
      />
    </Suspense>
  );
};
NotifyContainer.propTypes = {
};

NotifyContainer.defaultProps = {
};
export default NotifyContainer;
